import { render, staticRenderFns } from "./boruta_bar_chart.vue?vue&type=template&id=86be63e4&"
import script from "./boruta_bar_chart.vue?vue&type=script&lang=js&"
export * from "./boruta_bar_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports